module.exports = __webpack_public_path__ + "img/audio-mark3.c5e7e9a4.png";